import requestUtil from "../../../helpers/requestUtil";
import { setLoading } from "../../common/Loader/slice";
import * as Toasts from '../../common/Toastify';
import { setDropdownJobId, setFormData } from '../slice';
import { patchDynamicForm } from '../transformer';
import { setJobId, setLoadingFlagDecrement, setLoadingFlagIncrement, setViewVariableRate, updateJobDetails, updateJobFailed } from "./slice";
import { convertToString } from '../recurrenceConvertToString/recurrenceConvertToString'

export function getJobDetails(url, jobId, jobDate, jobsClaimId) {
    return async (dispatch, getState) => {
        const state = getState();
        const { formdata } = state.jobOpportunity;
        let str = ''
        // dispatch(setLoading(true));

        dispatch(setLoadingFlagIncrement())


        try {
            let newDynamicFormData = [];
            let dynamicFormData = []
            const params = {

                "jobUniqueId": jobId,
                "shiftDate": jobDate ? jobDate?.split('T')[0] : '',
                "jobsClaimId": jobsClaimId ? jobsClaimId : 0
            }
            const jobDetails = await requestUtil(`${url}/Employers/jobs/view`, 'POST', { ...params });
            if (jobDetails?.jobTypeID) {
                const response = await requestUtil(
                    `${url}/employers/get-dynamic-controls-for-job-creation`,
                    'POST',
                    { jobTypeId: jobDetails?.jobTypeID }
                );
                if (response?.tabsList) {
                    dynamicFormData = response?.tabsList
                }
            } else {
                dynamicFormData = formdata
            }

            // console.log('======jobDetails=======>', jobDetails)
            if (jobDetails?.jobProfileForms?.length > 0 && dynamicFormData?.length) {
                newDynamicFormData = patchDynamicForm(dynamicFormData, jobDetails?.jobProfileForms);
                dispatch(setFormData(newDynamicFormData));
            }
            if (jobDetails?.jobSummeryJobsShifts && jobDetails?.jobSummeryJobsShifts?.shiftType === 3) {
                if (jobDetails?.jobSummeryJobsShifts?.recurrenceRule !== '') {
                    str = convertToString(jobDetails?.jobSummeryJobsShifts?.recurrenceRule);
                }
            }
            dispatch(updateJobDetails({
                data: {
                    ...jobDetails, billingrate: jobDetails?.hourlyBillingRate ? jobDetails?.hourlyBillingRate : 0,
                    dynamicForm: newDynamicFormData, rrurleStr: str, recursionFlag: jobDetails?.jobSummeryJobsShifts?.shiftType, isAutoPostAllowed: jobDetails?.isAutoPostAllowed

                }
            }));
            // dispatch(setLoading(false));
            dispatch(setDropdownJobId(jobDetails?.jobTypeID))
        } catch (e) {
            dispatch(updateJobFailed(e.message));
            // dispatch(setLoading(false));
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}
export function updateJobId(jobId, backPath, editMode = false) {
    return async (dispatch) => {
        dispatch(setJobId({ jobId, backPath, editMode }));
    }
}

export const saveApproveJob = ({ url, params }) => {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // console.log(url, params);
        dispatch(setLoadingFlagIncrement())


        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            Toasts.success('Candidate Rating Saved Successfully.');
            // dispatch(setLoading(false));
        } catch (error) {
            // dispatch(setLoading(false));
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}

export const modifyCheckinCheckoutTime = ({ url, params }) => {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/Employers/jobs/update-checkin-checkout-View`, 'POST', { ...params });
            Toasts.success(response?.message);
            return response
        } catch (error) {
            Toasts.error(error?.message);
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}
export const modifyShiftEndTime = ({ url, params }) => {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/Employers/jobs/UpdateShiftEndTime`, 'POST', { ...params });
            Toasts.success(response?.message);
            return response
        } catch (error) {
            Toasts.error(error?.message);
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}


export const getViewVariableRateDetails = ({ url, params }) => {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const response = await requestUtil(`${url}/Employers/get-variable-payrate`, 'POST', { ...params });
            if (response?.payRates) {
                dispatch(setViewVariableRate({
                    name: 'viewPayRate',
                    value: response?.payRates,
                }))
            }
        } catch (error) {
            Toasts.success(error?.message);
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}
